import { HttpClient } from '@angular/common/http';
import { CertificadoService } from '../services/certificado.service';
import { MessageService } from '../services/message.service';
import { HttpUtilService } from '../services/http-util.service';
import { API_JAVA_CADASTRA_MAQUINA } from './../app.api';
import { API_JAVA_ALTERA_ESTADO_MAQUINA } from './../app.api';
import { OnInit, Injectable } from '@angular/core';
import { DadosCadastroMaquinaModel } from '../model/cadastra-maquina.model';
import { ConsultaMaquinaModel } from '../model/consulta-maquina.model';
import { DadosRetornoCadMaquinaModel, TokenMaquinaModel } from '../model/cadastra-maquina.model';
import { FingerPrintService } from '../services/fingerprint.service';
import { MatDialog } from '@angular/material';
import { ModalSalvaTokenUsuarioComponent } from '../modal-salva-token-usuario/modal-salva-token-usuario.component';

@Injectable({
  providedIn: 'root'
})

export class CadastraService implements OnInit {

  constructor(
    private http: HttpClient,
    public messageService: MessageService,
    private httpUtilService: HttpUtilService,
    private fingerPrintService: FingerPrintService,
    private dialog: MatDialog
  ) { }

  arquivo;
  dadosRetornoCadMaquinaModel: DadosRetornoCadMaquinaModel;
  tokenConteudo;
  ngOnInit(): void {

  }

  async cadastraMaquina(cadastraModel: DadosCadastroMaquinaModel, tokenMaquinaModel: TokenMaquinaModel) {

    
    this.montaTokenMaquina(cadastraModel.cnpjResponsavel, cadastraModel.fingerPrint, tokenMaquinaModel.jwt);
    const result = await this.httpUtilService.postWithHeader(API_JAVA_CADASTRA_MAQUINA,
      JSON.stringify(cadastraModel), cadastraModel.cnpjResponsavel, this.tokenConteudo);
    result.subscribe(data => {
      this.dadosRetornoCadMaquinaModel = data['data'];

      if (this.dadosRetornoCadMaquinaModel.status === '200') {

        this.armazenarToken(this.dadosRetornoCadMaquinaModel.token, cadastraModel.cnpjResponsavel);
        this.abrirModalSalvaTokenUsuario(cadastraModel.cnpjResponsavel);

      } else if (this.dadosRetornoCadMaquinaModel.code === '01') {
        this.messageService.add("Já existe cadastro para essa inscrição, por favor, acesse Consultar Máquina.");
      }
      else {       
        this.messageService.add(this.dadosRetornoCadMaquinaModel.mensagem);
      }
    }, err => {
      this.messageService.add("Erro no cadastramento da máquina.");
      console.error(err);
    });
  }


  async abrirModalSalvaTokenUsuario(inscricao) {
    const dialogRef = this.dialog.open(ModalSalvaTokenUsuarioComponent, {
      data: { inscricao: inscricao }
    });
    dialogRef.afterClosed().subscribe(data => {
      //    this.enviarAquivo();
    });
  }
  montaTokenMaquina(cnpj, fingerprint, jwtconteudo) {
    this.tokenConteudo = { id: cnpj, fingerprint: fingerprint, jwt: jwtconteudo }
  }

  private armazenarToken(tokenFull, inscricao) {
    this.fingerPrintService.armazenaToken(tokenFull);

  }

  async atualizaEstadoMaquina(alteraEstadoMaquina: ConsultaMaquinaModel) {

    const result = await this.httpUtilService.put(`${API_JAVA_ALTERA_ESTADO_MAQUINA}/${alteraEstadoMaquina.chaveMaquina}`, JSON.stringify(alteraEstadoMaquina));
    result.subscribe(data => {
      const mensagem = data['data']['mensagem'];
      const code = data['data']['code'];
      if (code === "0")
        this.messageService.add("Estado alterado com sucesso !  ");
      else
        this.messageService.add(mensagem);
    }, err => {
      console.error(err);
    });
  }

}